import Vue from 'vue';
import VueI18n from 'vue-i18n';
import appMessages from './locales';

/** Add/replace client's i18n translations */
import komacutMessages from './_komacut/locales';

// Get the local storage or default browser language
const defaultLanguage = (
  localStorage.locale
  || window.navigator.userLanguage
  || window.navigator.language
  || 'en'
).substr(0, 2).toLowerCase();

Vue.use(VueI18n);

export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || defaultLanguage,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || defaultLanguage,
  messages: _.defaultsDeep(
    {},
    appMessages,

    /** Add/replace client's i18n translations */
    komacutMessages,
  ),
});
